import AppNavbar from "./AppNavbar";
import Footer from "./Footer";
import resetImg from '../../assets/images/reset-password.png';
import '../../assets/css/resetPassword.scss';
import ResetPasswordComponent from "./ResetPasswordComponent";
import { useLocation } from "react-router-dom";

const ResetPassword = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    return (
        <div className="page-layout">
            {!token && <AppNavbar />}
            <div className="page-content">
                <div className="reset-password-container">
                    <div className="reset-password-first-div">
                        <img src={resetImg} alt="Reset Password" />
                    </div>
                    <div className="reset-password-second-div">
                        <ResetPasswordComponent />
                    </div>
                    {/* <div className="reset-password-second-div">
                        <div className="reset-box">
                            {(!isExpired && !successMessage) && (<>
                                <h2><b>Reset password</b></h2>
                                <p className="subtext">Just type it twice and try not to forget it.<br />Password should be and must contain:</p>
                                <div className="password-rules-box d-flex justify-content-between flex-wrap">
                                    <div className="rule-box">
                                        <div className={getTextClass(hasMinLength)}>8+</div>
                                        <span className={getTextClass(hasMinLength)}>Character</span>
                                    </div>
                                    <div className="rule-box">
                                        <div className={getTextClass(hasUpperCase)}>AA</div>
                                        <span className={getTextClass(hasUpperCase)}>Uppercase</span>
                                    </div>
                                    <div className="rule-box">
                                        <div className={getTextClass(hasLowerCase)}>aa</div>
                                        <span className={getTextClass(hasLowerCase)}>Lowercase</span>
                                    </div>
                                    <div className="rule-box">
                                        <div className={getTextClass(hasNumber)}>123</div>
                                        <span className={getTextClass(hasNumber)}>Number</span>
                                    </div>
                                    <div className="rule-box">
                                        <div className={getTextClass(hasSymbol)}>@#$</div>
                                        <span className={getTextClass(hasSymbol)}>Symbol</span>
                                    </div>
                                </div>

                                <Form className="mt-4" onSubmit={handleResetPassword}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>New Password</Form.Label>
                                        <div className="password-input-wrapper">
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                onFocus={() => setIsFocusedOrTyping(true)}
                                                onBlur={() => setIsFocusedOrTyping(false)}
                                            />
                                            <span
                                                className="eye-icon"
                                                onClick={() => setShowPassword(prev => !prev)}
                                            >
                                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                            </span>
                                        </div>
                                        {errorNewPassword && <div className="text-danger mt-1">{errorNewPassword}</div>}
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <Form.Label>Confirm Password</Form.Label>
                                        <div className="password-input-wrapper">
                                            <Form.Control
                                                type={showConfirmPassword ? "text" : "password"}
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <span
                                                className="eye-icon"
                                                onClick={() => setShowConfirmPassword(prev => !prev)}
                                            >
                                                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                            </span>
                                        </div>
                                        {errorConfirmPassword && <div className="text-danger mt-1">{errorConfirmPassword}</div>}
                                    </Form.Group>
                                    <Button className="reset-btn" type="submit" disabled={!canSubmit}>Reset Password</Button>
                                </Form>
                            </>)}
                            {isExpired && errorMessage && (
                                <div className="mt-3 d-flex flex-column justify-content-center align-items-center">
                                    <h2><b>Failed!</b></h2>
                                    <p className="text-danger">{errorMessage}</p>
                                    <img src={failedImg} alt="failed" className="p-4 success-image" />
                                    <Button className="reset-btn" onClick={handleFails}>Re-Send</Button>
                                </div>
                            )}

                            {successMessage && (
                                <div className="mt-3 d-flex flex-column justify-content-center align-items-center">
                                    <h2><b>Congratulations !</b></h2>
                                    <p className="text-success">{successMessage}</p>
                                    <img src={successImg} alt="success" className="p-4 success-image" />
                                    <Button className="reset-btn" onClick={handleSuccess}>{token ? 'Sign In' : 'Back'}</Button>
                                </div>
                            )}
                        </div>

                    </div> */}
                </div>
            </div>
            {!token && <Footer />}
        </div>
    );
};

export default ResetPassword;
